import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["iconButton", "badge", "dropdown", "list", "open", "delete", "total", "totalText"]

    OPEN_MESSAGE_FUNCTIONS = [];
    DELETE_MESSAGE_FUNCTIONS = [];
    BADGE_COUNT = 0;
    TOTAL_MESSAGES = 0;

    initialize() {
        super.initialize();
        this.BADGE_COUNT = 0;
        this.TOTAL_MESSAGES = parseInt(this.totalTarget.textContent);
        this.OPEN_MESSAGE_FUNCTIONS = [];
        this.toggleDropdownEH = this.toggleDropdown.bind(this);
        this.hideDropdownOnClickEH = this.hideDropdownOnClick.bind(this);
        this.openMessageEH = this.openMessage.bind(this);
        this.deleteMessageEH = this.deleteMessage.bind(this);
    }

    connect()
    {
        super.connect();
        this.BADGE_COUNT = parseInt(this.badgeTarget.textContent);

        this.iconButtonTarget.addEventListener("click", this.toggleDropdownEH)
        document.addEventListener("click", this.hideDropdownOnClickEH);

        this.openTargets.forEach(open => 
        {
            let openBound = this.openMessage.bind(this, open);
            this.OPEN_MESSAGE_FUNCTIONS.push(openBound);

            open.addEventListener("click", openBound)
        });

        
        this.deleteTargets.forEach(del => 
        {
            let deleteBound = this.deleteMessage.bind(this, del);
            this.DELETE_MESSAGE_FUNCTIONS.push(deleteBound);

            del.addEventListener("click", deleteBound)
        });
    }

    disconnect()
    {
        this.iconButtonTarget.removeEventListener("click", this.toggleDropdownEH);
        document.removeEventListener("click", this.hideDropdownOnClickEH);
        this.openTargets.forEach((open, i) => 
        {
            open.removeEventListener("click", this.OPEN_MESSAGE_FUNCTIONS[i]);
        });

        this.deleteTargets.forEach((del, i) => 
        {
            del.removeEventListener("click", this.DELETE_MESSAGE_FUNCTIONS[i]);
        });
        
        this.OPEN_MESSAGE_FUNCTIONS = [];
        this.DELETE_MESSAGE_FUNCTIONS = [];
        super.disconnect();
    }

    openMessage(element, e)
    {
        let message = element.closest(".message")
        let memoNum = message.dataset["memoNum"];

        message.classList.remove("new");
        this.BADGE_COUNT = this.BADGE_COUNT - 1;

        if(this.BADGE_COUNT == 0) this.badgeTarget.classList.add("hidden");

        this.badgeTarget.innerText = this.BADGE_COUNT;

        fetch(window.App.prefixedUrl("/memos/mark_as_read"),
        {
            method:"POST",
            body: JSON.stringify({memo_num: memoNum}),
            headers: {"content-type":"application/json"}
        })
        .then(res => res.json())
        .then(json =>
        {
            if(json.success)
            {
                let event = new CustomEvent("show-toast", { detail: "Message marked as read!" });
                window.dispatchEvent(event);
            }
            else
            {
                message.classList.add("new");

                this.BADGE_COUNT++;
                this.badgeTarget.innerText = this.BADGE_COUNT;
                if(this.badgeTarget.classList.contains("hidden"))
                    this.badgeTarget.classList.remove("hidden");

                let event = new CustomEvent("show-toast", { detail: "An error occurred when marking conversation as read." });
                window.dispatchEvent(event);
            }
        })
    }

    deleteMessage(element, e)
    {
        let message = element.closest(".message")
        let memoNum = message.dataset["memoNum"];

        if(message.classList.contains("new"))
        {
            this.BADGE_COUNT = this.BADGE_COUNT - 1;
            if(this.BADGE_COUNT == 0) this.badgeTarget.classList.add("hidden");
            this.badgeTarget.innerText = this.BADGE_COUNT;
        }

        let noMessages = document.createElement("div");
        noMessages.innerHTML = `<div class="text-muted px-4 pb-3 pt-2 flex items-center justify-start">No messages here yet.</div>`;
        noMessages = noMessages.firstElementChild;

        let count = this.notHiddenItemsCount(this.listTarget);

        message.classList.add("hidden");
        this.TOTAL_MESSAGES--;
        this.totalTarget.innerText = this.TOTAL_MESSAGES;

        if(this.TOTAL_MESSAGES == 1) this.totalTextTarget.innerText = "message";
        else if (this.TOTAL_MESSAGES == 0) this.totalTarget.parentElement.classList.add("hidden");

        if(count == 1)
        {
            this.listTarget.appendChild(noMessages);
            this.dropdownTarget.classList.add("empty");
        }

        fetch(window.App.prefixedUrl("/memos/delete"),
        {
            method:"POST",
            body: JSON.stringify({memo_num: memoNum}),
            headers: {"content-type":"application/json"}
        })
        .then(res => res.json())
        .then(json =>
        {
            if(json.success)
            {
                let event = new CustomEvent("show-toast", { detail: "Message deleted!" });
                window.dispatchEvent(event);

                let index = Array.from(this.listTarget.children).indexOf(message);
                this.listTarget.removeChild(message);

                this.DELETE_MESSAGE_FUNCTIONS.splice(index,1);
            }
            else
            {
                let event = new CustomEvent("show-toast", { detail: "An error occurred when deleting the memo." });
                window.dispatchEvent(event);
            }
        })
       
    }

    notHiddenItemsCount(list)
    {
        return Array.from(list.children).filter(item => !item.classList.contains("hidden")).length;
    }

    toggleDropdown(e)
    {
        this.dropdownTarget.classList.toggle("toast-invisible");
    }

    hideDropdownOnClick(e)
    {
        if (e.target == this.dropdownTarget ||
            this.dropdownTarget.contains(e.target) ||
            e.target == this.iconButtonTarget ||
            this.iconButtonTarget.contains(e.target)
        ) return;
        else this.dropdownTarget.classList.add("toast-invisible");
    }
}